import React, { useEffect, useState } from "react";
import { useFormik, useFormikContext } from "formik";
import { Link } from 'react-router-dom';
import {
  Checkbox,
  Grid,
  FormControlLabel,
  Button,
  Select,
  MenuItem,
  Radio,
  RadioGroup,
  FormControl,
  ListItemText,
  Box,
  Chip,
  FormLabel,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import Snackbar from "@mui/material/Snackbar";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CheckIcon from "@mui/icons-material/Check";
import Alert from "@mui/material/Alert";
import './index.css'
import { Container, ContainerForm, TextFieldStyled } from "./styles";
import { BASEURL } from "../../BaseURL";
import axios from "axios";
import { Navbar, Row, Col, Offcanvas } from 'react-bootstrap';

const initialValues = {
  amostra: "",
  numeroAmostra: "",
  relatoriosSelecionados: [],
  responsabilidadeAmostra: "",
  classificacao1: "",
  classificacao2: "",
  descricaoSolo: "",
  inundado: "",
  observacao: "",
};
const opcoesDisponiveis = [
  "Teor de umidade",
  "Compactação",
  "Análise granulométrica por peneiramento",
  "Análise granulométrica com sedimentação",
  "Massa específica real dos grãos",
  "Limites de liquidez e plasticidade (ATTERBERG)",
  "Índice de suporte Califórnia",
  "Determinação da massa específica aparente",
  "Massa específica máxima e mínima de areias",
  "Determinação do coeficiente de permeabilidade em carga variável em câmara triaxial",
  "Determinação do coeficiente de permeabilidade em carga constante em câmera triaxial",
];

const RelatorioSequencial = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingAproval, setIsLoadingAproval] = useState(false);
  const [valorAmostra, setValorAmostra] = useState(false);
  const [valorEnsaio, setValorEnsaio] = useState(false);
  const [error, setError] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [success, setSuccess] = useState("");
  const user = localStorage.getItem("usuario");
  // const values = null;
  const [showSidebar, setShowSidebar] = useState(false);
  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    //setBackgroundImage(images[index]);

  }
  const handleCloseSidebar = () => {
    setShowSidebar(false);

  }
  const [liClicked, setLiClicked] = useState(false);
  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      setIsLoading(!isLoading);
      console.log(BASEURL + "/reports/GenereteReports.php", values, {
        responseType: "arraybuffer",
      });
      axios
        .post(BASEURL + "/reports/GenereteReports.php", values, {
          responseType: "arraybuffer",
        })
        .then(function (response) {
          const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
          });
          const pdfUrl = URL.createObjectURL(pdfBlob);

          window.open(pdfUrl, "_blank");

          URL.revokeObjectURL(pdfUrl);
          setMensagem("Relatório gerado com sucesso!");
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
          }, 6000);
          setIsLoading(false);
        })
        .catch(function (error) {
          console.error("Erro na requisição:", error);
          setError(true);
          setTimeout(() => {
            setError(false);
          }, 6000);
          setIsLoading(false);
        });
    },
  });
  function aprovarRelatorio() {
    setIsLoadingAproval(true);
    let obj = {
      codSample: valorAmostra,
      numberSample: valorEnsaio,
      reportsSelect: formik.values.relatoriosSelecionados,
      user: user,
    };

    axios
      .post(BASEURL + "/AprovarRelatorioSequencial.php", obj)
      .then((response) => {
        setIsLoadingAproval(false);
        setMensagem("Relatório aprovado com sucesso!");
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
        }, 12000);
      })
      .catch((error) => {
        console.error("Erro na solicitação:", error);
        setIsLoadingAproval(false);
      });
  }
  useEffect(() => {
    if (valorAmostra && valorEnsaio) {
      axios
        .get(
          BASEURL +
          "/BuscarRelatorioSequencial.php?amostra=" +
          valorAmostra +
          "&numeroAmostra=" +
          valorEnsaio
        )
        .then((response) => {
          console.log("Resposta do servidor:", response.data);

          // Acessando o valor do campo 'success'
          const success = response.data.success;
          console.log("Success:", success);

          if (success) {
            const data = response.data.data;
            formik.setFieldValue(
              "responsabilidadeAmostra",
              data.Responsabilidade_Amostragem
            );
            formik.setFieldValue("descricaoSolo", data.DescricaoDoSolo);
            formik.setFieldValue("classificacao1", data.Class_1);
            formik.setFieldValue("classificacao2", data.Class_2);
            formik.setFieldValue("inundado", data.Inundado_naoinundado);
          } else {
            console.error("A solicitação não foi bem-sucedida:", response.data);
          }
        })
        .catch((error) => {
          console.error("Erro na solicitação:", error);
        });
    }
  }, [valorEnsaio]);
  return (
    <>

      {error ? (
        <Snackbar open={true} autoHideDuration={6000}>
          <Alert
            severity={"error"}
            sx={{
              width: "100%",
              backgroundColor: "#ff7b5a",
              color: "#FFF",
            }}
          >
            Amostra e/ou número de ensaio não encontrado
          </Alert>
        </Snackbar>
      ) : (
        success && (
          <Snackbar open={true} autoHideDuration={6000}>
            <Alert
              severity={"success"}
              sx={{
                width: "100%",
                backgroundColor: "#238E23",
                color: "#FFF",
              }}
            >
              {mensagem}
            </Alert>
          </Snackbar>
        )
      )}
      <div className="home" style={{ backgroundColor: '#DEDACF', height: 'auto', width: 'auto' }}>

        <Container>

        </Container>

        <Container>
          <div className="sidebar-button1">
            <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button1">
              <div className="icon-container1">
                <i className="bi bi-list icon-circle"></i>
              </div>
            </Button>

          </div>
          <ContainerForm>
            <h1></h1>
            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextFieldStyled
                    fullWidth
                    disabled={isLoading || isLoadingAproval}
                    id="amostra"
                    name="amostra"
                    label="Amostra"
                    onChange={formik.handleChange}
                    value={formik.values.amostra}
                    onBlur={(e) => {
                      setValorAmostra(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextFieldStyled
                    fullWidth
                    disabled={isLoading || isLoadingAproval}
                    id="numeroAmostra"
                    name="numeroAmostra"
                    label="Número da Amostra"
                    onChange={formik.handleChange}
                    value={formik.values.numeroAmostra}
                    onBlur={(e) => {
                      setValorEnsaio(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <p>Informe os relatórios que deseja:</p>
                  <Select
                    disabled={isLoading || isLoadingAproval}
                    labelId="relatoriosSelecionados-label"
                    id="relatoriosSelecionados"
                    name="relatoriosSelecionados"
                    multiple
                    fullWidth
                    sx={{ backgroundColor: "#fff" }}
                    value={formik.values.relatoriosSelecionados}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "relatoriosSelecionados",
                        e.target.value
                      )
                    }
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((option) => (
                          <Chip key={option} label={option} />
                        ))}
                      </Box>
                    )}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 200,
                        },
                      },
                    }}
                  >
                    {opcoesDisponiveis.map((opcao) => (
                      <MenuItem key={opcao} value={opcao}>
                        <Checkbox
                          checked={
                            formik.values.relatoriosSelecionados.indexOf(opcao) >
                            -1
                          }
                        />
                        <ListItemText primary={opcao} />
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <TextFieldStyled
                    fullWidth
                    disabled={isLoading || isLoadingAproval}
                    id="responsabilidadeAmostra"
                    name="responsabilidadeAmostra"
                    label="Responsabilidade da amostragem"
                    onChange={formik.handleChange}
                    value={formik.values.responsabilidadeAmostra}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextFieldStyled
                    fullWidth
                    disabled={isLoading || isLoadingAproval}
                    id="classificacao1"
                    name="classificacao1"
                    label="Classificação (ASTM D2487-00)"
                    onChange={formik.handleChange}
                    value={formik.values.classificacao1}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextFieldStyled
                    fullWidth
                    disabled={isLoading || isLoadingAproval}
                    id="classificacao2"
                    name="classificacao2"
                    label="Classificação (ASTM D3282-09)"
                    onChange={formik.handleChange}
                    value={formik.values.classificacao2}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextFieldStyled
                    id="descricaoSolo"
                    disabled={isLoading || isLoadingAproval}
                    name="descricaoSolo"
                    label="Descrição do solo"
                    multiline
                    fullWidth
                    rows={4}
                    onChange={formik.handleChange}
                    value={formik.values.descricaoSolo}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextFieldStyled
                    id="observacao"
                    disabled={isLoading || isLoadingAproval}
                    name="observacao"
                    label="Observação folha de rosto"
                    multiline
                    fullWidth
                    rows={4}
                    onChange={formik.handleChange}
                    value={formik.values.observacao}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Status de Inundação</FormLabel>
                    <RadioGroup
                      disabled={isLoading || isLoadingAproval}
                      aria-label="inundado"
                      name="inundado"
                      value={formik.values.inundado}
                      onChange={formik.handleChange}
                    >
                      <FormControlLabel
                        value="Inundado"
                        disabled={isLoading || isLoadingAproval}
                        control={<Radio />}
                        label="Inundado"
                      />
                      <FormControlLabel
                        value="NaoInundado"
                        disabled={isLoading || isLoadingAproval}
                        control={<Radio />}
                        label="Não Inundado"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <LoadingButton
                    fullWidth
                    disabled={isLoadingAproval}
                    loading={isLoading}
                    type="submit"
                    variant="contained"
                    color="success"
                    endIcon={<PictureAsPdfIcon />}
                  >
                    Gerar relatório
                  </LoadingButton>
                </Grid>
                <Grid item xs={6}>
                  <LoadingButton
                    fullWidth
                    disabled={isLoading}
                    loading={isLoadingAproval}
                    onClick={aprovarRelatorio}
                    variant="contained"
                    endIcon={<CheckIcon />}
                    sx={{
                      backgroundColor: "#6B8E23",
                      "&:hover": {
                        backgroundColor:
                          "#4B6A1D" /* Cor verde mais escura quando o mouse passa por cima */,
                      },
                    }}
                  >
                    Aprovar relatório
                  </LoadingButton>
                </Grid>
              </Grid>
            </form>
          </ContainerForm>
        </Container>
        <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
          <div className="offcanvas-header">
            
            <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
          </div>
          <Offcanvas.Body>
            <ul>
              <li className={`${liClicked ? 'li-slide-right' : ''}`} >
                                <Link to="/app/laboratorio" style={{ textDecoration: 'none' }}>
                                    <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
                            </li>
              {/* <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked1 ? '#00221A' : 'white', fontSize: '1.5em' }}>Sobre o Geo+ <span className="icon-right move-right1">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked1 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
              {/* <li className={liClicked2 ? 'li-slide-right' : ''} >
              <Button variant="link" style={{ textDecoration: 'none', color: 'white', fontSize: '1.5em' }}>Suporte <span className="icon-right move-right2">
                <i className="bi bi-chevron-right"></i>
              </span></Button>
            </li> */}
              {/* <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
            </ul>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default RelatorioSequencial;
